export default "__VITE_ASSET__ad566cba__"